import React from "react";
import ReservationSegmentCardStore from "./stores/ReservationSegmentCardStore";
import ReservationSegmentCardActions from "./actions/ReservationSegmentCardActions";
import Tabs from "../Tabs/Tabs";
import ReservationSegmentCardWorkspace from "./ReservationSegmentCardWorkspace";
import ModalHeader from "../ModalButtons/ModalHeader";
import ModalButtons from "../ModalButtons/ModalButtons";

export default class ReservationSegmentCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.getStateFromStores();
    this.onChangePaymentAmount = this.onChangePaymentAmount.bind(this);
    this.onChangePaymentCard = this.onChangePaymentCard.bind(this);
    this.onChangePaymentCustomer = this.onChangePaymentCustomer.bind(this);
    this._onChange = this._onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onCloseAndRefresh = this.onCloseAndRefresh.bind(this);
  }

  componentDidMount() {
    ReservationSegmentCardStore.addChangeListener(this._onChange);
    ReservationSegmentCardActions.init(this.props);
    var props = this.props;

    $(window).on("refresh_data_table",  () => {
      this.setState({ reLoadData : true})
      ReservationSegmentCardActions.refresh(props);
    });
  }

  getStateFromStores() {
    return ReservationSegmentCardStore.getState();
  }

  incidentalDepositCardCustomer(customer_id) {
    var self = this;
    var cust_obj = null;
    self.state.reservation_segment.customers.map(function (customer) {
      if (customer.id === customer_id) {
        cust_obj = customer;
      }
    });

    return cust_obj;
  }

  render() {
    var buttons = [
      {
        name: I18n.t("done"),
        html_attributes: ['data-dismiss="modal"'],
        onClick: (e) => {
          this.onCloseAndRefresh();
        },
      },
    ];

    return (
      <div className="ReservationSegmentCard">
        <Tabs tabs={this.tabs()} />
        <div className="panel panel-form">
          <ModalHeader onClick={this.onCloseAndRefresh} />
          <ModalButtons loading={this.state.loading} buttons={buttons} />
          {this.state.initialized ? (
            <ReservationSegmentCardWorkspace {...this.state} 
              refreshFolioTableCallback={this.refreshFolioTableCallback}
              reservation_segment_folios_path={this.props.reservation_segment_folios_path}
              ru_reservation={this.props.ru_reservation}
              reservation_ru_queue_logs_path={this.props.reservation_ru_queue_logs_path}
              reservation_segment_reservation_ru_queue_logs_data_table={this.props.reservation_segment_reservation_ru_queue_logs_data_table}
            />
          ) : null}
        </div>
      </div>
    );
  }

  tabs() {
    if (
      this.state.reservation_segment &&
      this.state.reservation_segment.status != "held"
    ) {
      return [
        {
          tabName: I18n.t("details"),
          targetName: "details",
          classes: this.state.active_tab === "details" ? "active" : null,
          changeHandler: this.onChangeTab,
        },
        {
          tabName: I18n.t("folios"),
          targetName: "folios",
          classes: this.state.active_tab === "folios" ? "active" : null,
          changeHandler: this.onChangeTab,
        },
        {
          tabName: I18n.t("emails"),
          targetName: "emails",
          classes: this.state.active_tab === "emails" ? "active" : null,
          changeHandler: this.onChangeTab,
        },
        ...(this.props.property.enable_messaging
          ? [
              {
                tabName: I18n.t("text_messages"),
                targetName: "message_logs",
                classes: this.state.active_tab === "message_logs" ? "active" : null,
                changeHandler: this.onChangeTab,
              },
            ]
          : []),
        {
          tabName: I18n.t("housekeeping"),
          targetName: "housekeeping",
          classes: this.state.active_tab === "housekeeping" ? "active" : null,
          changeHandler: this.onChangeTab,
        },
        {
          tabName: I18n.t("service_requests"),
          targetName: "service-logs",
          classes: this.state.active_tab === "service-logs" ? "active" : null,
          changeHandler: this.onChangeTab,
          labelCount: this.state.service_request_count,
        },
        {
          tabName: I18n.t("notes"),
          targetName: "notes",
          classes: this.state.active_tab === "notes" ? "active" : null,
          changeHandler: this.onChangeTab,
          labelCount: this.state.note_count,
        },
        {
          tabName: I18n.t("forms"),
          targetName: "forms",
          classes: this.state.active_tab === "forms" ? "active" : null,
          changeHandler: this.onChangeTab,
          labelCount: this.props.form_count,
        },
        {
          tabName: I18n.t("system_notifications"),
          targetName: "system_notifications",
          classes: this.state.active_tab === "system_notifications" ? "active" : null,
          changeHandler: this.onChangeTab,
          labelCount: this.state.system_notification_count,
        },
        ...(this.props.superadmin_user && this.props.ru_queue_logs_present
          ? [
            {
              tabName: I18n.t("ru_queue_logs"),
              targetName: "ru_queue_logs",
              classes:
                this.state.active_tab === "ru_queue_logs" ? "active superadmin-tool" : "superadmin-tool",
              changeHandler: this.onChangeTab,
            },
          ]
          : []),
      ];
    } else {
      return [
        {
          tabName: I18n.t("details"),
          targetName: "details",
          classes: this.state.active_tab === "details" ? "active" : null,
          changeHandler: this.onChangeTab,
        },
        {
          tabName: I18n.t("housekeeping"),
          targetName: "housekeeping",
          classes: this.state.active_tab === "housekeeping" ? "active" : null,
          changeHandler: this.onChangeTab,
        },
        {
          tabName: I18n.t("service_requests"),
          targetName: "service-logs",
          classes: this.state.active_tab === "service-logs" ? "active" : null,
          changeHandler: this.onChangeTab,
          labelCount: this.state.service_request_count,
        },
        {
          tabName: I18n.t("notes"),
          targetName: "notes",
          classes: this.state.active_tab === "notes" ? "active" : null,
          changeHandler: this.onChangeTab,
          labelCount: this.state.note_count,
        },
      ];
    }
  }

  onCloseAndRefresh() {
    parent.refresh_data();
    parent.hide_modal();
  }

  onChangeTab(name) {
    ReservationSegmentCardActions.setActiveTab(name);
  }

  onSubmit() {
    ReservationSegmentCardActions.checkIn();
  }

  onChangePaymentCard(card_id) {
    ReservationSegmentCardActions.changePaymentCard(card_id);
  }

  onChangePaymentCustomer(customer) {
    ReservationSegmentCardActions.changePaymentCustomer(customer);
  }

  onChangePaymentAmount(amount) {
    ReservationSegmentCardActions.changePaymentAmount(amount);
  }

  onChangePaymentType(type) {
    ReservationSegmentCardActions.changePaymentType(type);
  }

  _onChange() {
    this.setState(this.getStateFromStores());
  }

  refreshFolioTableCallback = () => {
    this.setState({ reLoadData: false })
  }
}